module.exports = __webpack_public_path__ + "static/img/3_10_1.e72bbed3.jpg";